import React from 'react';
import { cn } from '../../../lib/utils';
import { FormattedMoodboardItem } from '../../../hooks/queries/moodboardTypes';
import { ImageItem } from './ImageItem';

interface ImageGridProps {
  images: FormattedMoodboardItem[];
  isMobile: boolean;
  columns: number;
  onDelete: (imageId: string) => void;
  selectedImages: Set<string>;
  onSelectImage: (imageId: string) => void;
}

export function ImageGrid({
  images,
  isMobile,
  columns,
  onDelete,
  selectedImages,
  onSelectImage,
}: ImageGridProps) {
  return (
    <div
      className={cn(
        'grid gap-4 w-full',
        isMobile
          ? 'grid-cols-2 pb-32' // Add bottom padding for mobile to account for buttons
          : `grid-cols-${columns}`
      )}
      style={{
        gridTemplateColumns: !isMobile ? `repeat(${columns}, minmax(0, 1fr))` : undefined,
        gap: '1rem', // Consistent 16px gap
      }}
    >
      {images.map(image => (
        <ImageItem
          key={image.id}
          image={image}
          onDelete={onDelete}
          isSelected={selectedImages.has(image.id)}
          onSelect={onSelectImage}
        />
      ))}
    </div>
  );
}
